<template>
  <b-modal
    :title="tituloModal"
    cancel-title="Cerrar"
    ok-title="Cerrar"
    size="xl"
    v-model="modalSujeto"
    @ok="modalSujeto = false"
    ok-only
  >
    <div>
      <b-row>
        <b-col lg="12">
          <b-card-body>
            <b-row>
              <b-col sm="4">
                <b-form @submit.prevent="buscar">
                  <b-form-group
                    label="Búsqueda"
                    label-for="elementsAppendButton"
                    description=""
                  >
                    <b-input-group prepend="">
                      <b-form-input
                        type="text"
                        v-model="busqueda"
                      ></b-form-input>
                      <b-dropdown
                        :text="textoAccion"
                        variant="primary"
                        slot="prepend"
                      >
                        <b-dropdown-item @click="setearAccion('codigo')">Código</b-dropdown-item>
                        <b-dropdown-item @click="setearAccion('idnacion')">Id Nación</b-dropdown-item>
                        <b-dropdown-item @click="setearAccion('nombre')">Nombre</b-dropdown-item>
                      </b-dropdown>
                      <b-input-group-append>
                        <b-button
                          type="submit"
                          variant="primary"
                        >Buscar</b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </b-form>
              </b-col>
              <b-col
                v-if="data.length > 0"
                sm="4"
              >
                <b-form-group
                  label="Filtrar resultados"
                  label-for="filtroAsegurados"
                  
                  
                >
                  <b-form-input
                    id="filtroAsegurados"
                    type="text"
                    placeholder=""
                    v-model="filters[0].value"
                  >
                  </b-form-input>
                </b-form-group>
              </b-col>
              <b-col
                v-if="data.length > 0"
                sm="4"
              >
                <b-form-group
                  label="Filtrar por país"
                  label-for="filtroPais"
                  
                  
                >
                  <b-form-select
                    id="filtroPais"
                    v-model="filters[1].value"
                  >
                    <option value="">Todos</option>
                    <option
                      v-for="pais in filtroPaises"
                      :value="pais" v-bind:key = pais
                    >{{ pais }}</option>
                  </b-form-select>
                </b-form-group>
              </b-col>
            </b-row>
            <data-tables
              :data="data"
              :table-props="tableProps"
              :filters="filters"
              :page-size="10"
              :pagination-props="{ pageSizes: [10, 20, 50] }"
              :action-col="actionCol"
            >
              <el-table-column
                v-for="title in titles"
                :prop="title.prop"
                :label="title.label"
                :key="title.label"
                sortable="custom"
              >
              </el-table-column>
            </data-tables>
          </b-card-body>
        </b-col>
      </b-row>
    </div>
  </b-modal>
</template>
<script>
import axios from "axios";
import { tablasMixin } from "../../components/mixins/tablasMixin";
import apiSeleccionarSujeto from "../../components/services/apiSeleccionarSujeto";
import { globalesMixin } from "../../components/mixins/globalesMixin";

export default {
  name: "SeleccionarSujeto",
  mixins: [tablasMixin, globalesMixin],
  data: function() {
    return {
      modalSujeto: false,
      busqueda: "",
      accion: "codigo",
      textoAccion: "Código",
      parametroBusqueda: "",
      tituloModal: "",
      tipoBusqueda: "",
      tipo: "",
      data: [],
      filtroPaises: [],
      titles: [
        {
          prop: "percodigo",
          label: "Código"
        },
        {
          prop: "peridnacion",
          label: "Id. Nacional"
        },
        {
          prop: "pernacion",
          label: "Nación"
        },
        {
          prop: "perdireccion",
          label: "Dirección"
        },
        {
          prop: "perciudad",
          label: "Ciudad"
        },
        {
          prop: "percomuna",
          label: "Comuna"
        },
        {
          prop: "pernombreimp",
          label: "Nombre"
        }
      ],
      filters: [
        {
          prop: [
            "percodigo",
            "peridnacion",
            "pernacion",
            "perdireccion",
            "perciudad",
            "percomuna",
            "pernombreimp"
          ],
          value: ""
        },
        {
          prop: ["pernacion"],
          value: ""
        }
      ],
      actionCol: {
        label: "Seleccionar",
        props: {
          align: "center"
        },
        buttons: [
          {
            props: {
              icon: "fa fa-check"
            },
            handler: row => {
              this.sujetoSeleccionado(
                row.percodigo,
                row.pernombreimp,
                row.peridnacion
              );
            },
            label: " Seleccionar"
          }
        ]
      }
    };
  },
  methods: {
    setearAccion(accion) {
      if (accion == "codigo") {
        this.accion = "codigo";
        this.textoAccion = "Código";
      }
      if (accion == "idnacion") {
        this.accion = "idnacion";
        this.textoAccion = "Id Nación";
      }
      if (accion == "nombre") {
        this.accion = "nombre";
        this.textoAccion = "Nombre";
      }
    },
    buscar() {
      if (this.busqueda == "") {
        this.data = [];
        this.filtroPaises = [];
        return;
      }
      this.data = [];
      if (this.accion == "codigo") {
        // comenzar barra de progreso
        this.$Progress.start();
        return apiSeleccionarSujeto
          .obtenerSujetoPorCodigo(
            this.$session.get("mail"),
            this.$session.get("usuarioInterno"),
            this.busqueda,
            this.tipo
          )
          .then(response => {
            response.data = this.keysMinuscula(response.data);
            this.obtenerListadoPaises(response.data.res);
            this.data = response.data.res;
            this.$Progress.finish();
          })
          .catch(error => {
            this.crearNotificacion("Error de sistema", error, "error");
          });
      }
      if (this.accion == "idnacion") {
        // comenzar barra de progreso
        this.$Progress.start();
        return apiSeleccionarSujeto
          .obtenerSujetoPorIdNacion(
            this.$session.get("mail"),
            this.$session.get("usuarioInterno"),
            this.busqueda,
            this.tipo
          )
          .then(response => {
            response.data = this.keysMinuscula(response.data);
            this.obtenerListadoPaises(response.data.res);
            this.data = response.data.res;
            this.$Progress.finish();
          })
          .catch(error => {
            this.crearNotificacion("Error de sistema", error, "error");
          });
      }
      if (this.accion == "nombre") {
        // comenzar barra de progreso
        this.$Progress.start();
        return apiSeleccionarSujeto
          .obtenerSujetoPorNombre(
            this.$session.get("mail"),
            this.$session.get("usuarioInterno"),
            this.busqueda,
            this.tipo
          )
          .then(response => {
            response.data = this.keysMinuscula(response.data);
            this.obtenerListadoPaises(response.data.res);
            this.data = response.data.res;
            this.$Progress.finish();
          })
          .catch(error => {
            this.crearNotificacion("Error de sistema", error, "error");
          });
      }
    },
    obtenerListadoPaises(paises) {
      this.filtroPaises = [];
      paises.forEach(pais => {
        if (!this.filtroPaises.includes(pais.pernacion)) {
          this.filtroPaises.push(pais.pernacion);
        }
      });
    },
    sujetoSeleccionado(percodigo, pernombreimp, peridnacion) {
      this.$emit("sujetoSeleccionado", {
        tipoBusqueda: this.tipoBusqueda,
        percodigo: percodigo,
        pernombreimp: pernombreimp,
        peridnacion: peridnacion
      });
    }
  }
};
</script>
